import React, { useEffect, useState } from "react";
import FAQ from "./functions";
import { GET_FAQ_URL } from "../apiEndpoints";

export default function FaqTest() {
  const [faqs, setFaqs] = useState([
    // {
      
    //   question: "What is the UWI Mapping Initiative Platform?",
    //   answer:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed pharetra lorem eu dolor rhoncus, at scelerisque ligula gravida. Sed porta id mi sit amet convallis. Etiam iaculis massa sit amet lacus blandit sodales. Nulla ultrices velit a diam placerat congue. Pellentesque iaculis, ipsum quis eleifend dapibus, est dui eleifend ante, quis fermentum mi ligula quis nisl. Ut et ex dui. Integer id venenatis quam.",
    //   open: false
    // },
    // {
    //   question: "How often are projects updated?",
    //   answer: "You! The viewer!",
    //   open: false
    // },
    // {
    //   question:
    //     "How do I find out more?",
    //   answer: "This many!",
    //   open: false
    // }
  ]);

  const toggleFAQ = index => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };
  useEffect(()=>{
    const getfaqData=async()=>{
      let response =await fetch(GET_FAQ_URL,{
        method: 'GET',
      })
      let data=await response.json()
      if (response.status===200){
        setFaqs(data)
        // console.log(data)
        // console.log(faqs)
      }
        else{
          console.log('error here')
        }
      }
      getfaqData()
  },[])
  
    
  return (
      <body className = 'faq-bdy' id='faq-bdy'>
          <div className="faq">
            <div className="faq-content">
                <div className="faq-text">
                    <h1 className = 'faq-h1'>FAQs</h1>
                    <p className = 'faq-p'>
                        Have questions? These are the most asked questions.
                    </p>
                </div>
            </div>
      <div className="faqs">
        {faqs.map((faq, index) => (
        <FAQ faq={faq} index={index} key={index} toggleFAQ={toggleFAQ} />
        ))}
      </div>
    </div>

      </body>
           );
}
